module.exports = __webpack_public_path__ + "static/Fallback06-e965564f7fa72cbfe2259d37581c780b.jpg";